import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CoreRoutingModule } from './core-routing.module';
import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Components
import { HeaderComponent } from './header/header.component';
import { LoginComponent } from './login/login.component';
import { LoadingBarComponent } from './loading-bar/loading-bar.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { SetPasswordFormComponent } from './login/login-form-templates/set-password.component';
import { ForgotPasswordFormComponent } from './login/login-form-templates/forgot-password.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { MainLoginFormComponent } from './login/main-login-form/main-login-form.component';
import { DoNotMailComponent } from './do-not-mail/do-not-mail.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsAndConditionsTemplateComponent } from './terms-and-conditions-template/terms-and-conditions-template.component';
import { UserRoleChangePanelComponent } from './user-role-change-panel/user-role-change-panel.component';
import { CompanySelectionComponent } from './login/main-login-form/company-selection/company-selection.component';

@NgModule({ declarations: [
        HeaderComponent,
        LoginComponent,
        SetPasswordFormComponent,
        ForgotPasswordFormComponent,
        LoadingBarComponent,
        TermsConditionsComponent,
        SignUpComponent,
        MainLoginFormComponent,
        DoNotMailComponent,
        ContactUsComponent,
        PrivacyPolicyComponent,
        TermsAndConditionsTemplateComponent,
        UserRoleChangePanelComponent,
        CompanySelectionComponent
    ],
    exports: [
        RouterModule,
        HeaderComponent,
        LoadingBarComponent
    ], imports: [CommonModule,
        CoreRoutingModule,
        SharedModule,
        NgbModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CoreModule { }
